import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import _ from "i18n";
import Lottie from "react-lottie";
import styles from "./NotFound.local.scss";
import * as error404Data from "../Common/lottie-animations/error-404.json";
import * as nothingFoundData from "../Common/lottie-animations/nothing-found.json";
import * as accessDenied from "../Common/lottie-animations/access-denied.json";
import { inIframe, postMessage } from "Utils";

export default class NotFoundV2 extends Component {
  defaultOptions = {
    loop: true,
    autoplay: true
  };
  componentDidMount() {
    if (inIframe()) {
      this.deleteHeader();
      postMessage(
        window.document.getElementsByClassName("off-canvas-wrapper").item(0)
          .scrollHeight,
        "NEW_HEIGHT"
      );
    }
  }
  deleteHeader = () => {
    /*  let Menu = document.getElementById("mainMenu");
    let subMenu = document.getElementById("subMenu");

    Menu && Menu.remove();
    subMenu && subMenu.remove();*/
  };
  render() {
    let {
      mainClass,
      children,
      text,
      subText,
      accountingSubText,
      errorPageType
    } = this.props;
    let renderedTxt;

    switch (errorPageType) {
      case "ERROR_404":
        renderedTxt = (
          <div className={styles.not_found_v2__main}>
            <Lottie
              options={{ ...this.defaultOptions, animationData: error404Data }}
              height={360}
              isClickToPauseDisabled={true}
            />
            <h2>{_("Oops")}</h2>
            <h5>{_("You've moved so fast and got lost...")}</h5>
            <p>{_("pageNotFound")}</p>
            {!this.props.buttonIgnored ? (
              <button className="btn secondary">
                <i className="icon-arrow-left" /> &nbsp;&nbsp;&nbsp;&nbsp;
                <NavLink to="/">{_("goBack")}</NavLink>
              </button>
            ) : (
              ""
            )}
          </div>
        );
        break;

      case "ACCESS_DENIED":
        renderedTxt = (
          <div className={styles.not_found_v2__main}>
            <Lottie
              options={{ ...this.defaultOptions, animationData: accessDenied }}
              height={360}
              isClickToPauseDisabled={true}
            />
            <h2>{_("Oops")}</h2>
            {subText &&
              window.location === window.parent.location && (
                <h5>{_(subText)}</h5>
              )}
            {accountingSubText &&
              window.location !== window.parent.location && (
                <h5>{_(accountingSubText)}</h5>
              )}
            <p>{_(text)}</p>
            {/*<p>{_("accessDenied")}</p>*/}
            {!this.props.buttonIgnored ? (
              <button
                className="btn secondary"
                style={{ marginLeft: 12, marginTop: 10 }}
              >
                <i className="icon-arrow-left" /> &nbsp;&nbsp;&nbsp;&nbsp;
                <NavLink to="/">{_("goBack")}</NavLink>
              </button>
            ) : (
              ""
            )}
          </div>
        );
        break;

      default:
        renderedTxt = (
          <div className={styles.not_found_v2__main}>
            <Lottie
              options={{
                ...this.defaultOptions,
                animationData: nothingFoundData
              }}
              height={360}
              isClickToPauseDisabled={true}
            />
            <h2>{_("Nothing Found")}...</h2>
            <p>{_(text || "nothingFound")}</p>
          </div>
        );
        break;
    }

    return (
      <div className={`${styles.not_found_v2} ${mainClass}`}>
        {children || renderedTxt}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NotFound/NotFoundV2.js